import { useRef, useCallback } from 'react'

/**
 * Check if DOM is updated and scrollRef is available
 * then we can to Scroll to targeted ref. and scroll will be handled by Site Buidler.
 */
export const useHookWithRefCallback = () => {
  const scrollRef = useRef(null)
  const setScrollRef = useCallback((node) => {
    if (node) {
      node.scrollIntoView({ behavior: 'smooth' })
    }
    scrollRef.current = node
  }, [])

  return [setScrollRef]
}
